export default __webpack_public_path__ + "static/feature1-815f2024f563592e732edcd5c338208f.png";